import {
  selectorFamily
} from 'recoil';
import * as vodaLend from '../api/vodaLend';

const fetchOfferDetail = async ({ businessId, offerId }) => await vodaLend.getOfferDetails({ businessId, offerId });

const fetchOffersList = async (businessId) => await vodaLend.getOffersList(businessId);

const postAcceptOffers = async ({ businessId, offerId }) => await vodaLend.acceptOffers({ businessId, offerId });

export const offersListState = selectorFamily({
  key: 'offersListState',
  get: (businessId) => async () => await fetchOffersList(businessId)
});

export const offerDetailsByOfferId = selectorFamily({
  key: 'offerDetailsByOfferId',
  get: ({ businessId, offerId }) => async () => await fetchOfferDetail({ businessId, offerId })
});

export const acceptOffers = selectorFamily({
  key: 'acceptOffers',
  get: ({ businessId, offerId }) => async () => await postAcceptOffers({ businessId, offerId })
});
